import React, { useRef, useState } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import BackgroundEffectsModal from '../shared/BackgroundEffectsModal';
import MeetingLobbyDeviceButton from './MeetingLobbyDeviceButton';

/**
 * Blur and backgrounds, chosen before anyone sees you. Unlike its neighbours it
 * opens something rather than toggling something, so it has no off state — and
 * it owns both the modal and the element the modal hangs off, which is why the
 * anchor lives here rather than in the row.
 */
const MeetingLobbyBackgroundEffectsButton = () => {
    const { i18next } = useAppContext();
    const [showBackgroundEffects, setShowBackgroundEffects] = useState(false);
    const anchorRef = useRef<HTMLDivElement>(null);

    return (
        <>
            <div ref={anchorRef} className="flex">
                <MeetingLobbyDeviceButton
                    dataTestId="meeting-lobby-background-effects-button"
                    iconKey="photo_filter"
                    onClick={() =>
                        setShowBackgroundEffects((isOpen) => !isOpen)
                    }
                    tooltipLabel={i18next.t(
                        'videoconference.background_effects.title',
                    )}
                />
            </div>

            {showBackgroundEffects && (
                <BackgroundEffectsModal
                    anchorEl={anchorRef.current}
                    placement="top"
                    followAppTheme={true}
                    onClose={() => setShowBackgroundEffects(false)}
                />
            )}
        </>
    );
};

export default MeetingLobbyBackgroundEffectsButton;
